import { render, staticRenderFns } from "./imgW.vue?vue&type=template&id=d1f61790"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1f61790')) {
      api.createRecord('d1f61790', component.options)
    } else {
      api.reload('d1f61790', component.options)
    }
    module.hot.accept("./imgW.vue?vue&type=template&id=d1f61790", function () {
      api.rerender('d1f61790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgW.vue"
export default component.exports